const REG_SEP = /&/
const REG_PLUS = /\+/g

const hasOwnProperty = Object.prototype.hasOwnProperty

const returnVal = function (val) { return val }

/**
 * @param {string} string
 * @param {boolean} [shouldDecode=true]
 * @return {Object}
 */
function parse (string, shouldDecode) {
  if (shouldDecode === void 0) shouldDecode = true

  const queryArray = string.split(REG_SEP)

  const decode = shouldDecode ? decodeURIComponent : returnVal

  return queryArray.reduce(function (query, item) {
    item = item.replace(REG_PLUS, '%20')

    const eqIndex = item.indexOf('=')
    let key, value

    if (eqIndex < 0) {
      key = item
      value = ''
    } else {
      key = item.slice(0, eqIndex)
      value = item.slice(eqIndex + 1)
    }

    key = decode(key)
    value = decode(value)

    if (!hasOwnProperty.call(query, key)) {
      query[key] = value
    } else if (Array.isArray(query[key])) {
      query[key].push(value)
    } else {
      query[key] = [query[key], value]
    }

    return query
  }, {})
}

/**
 * @param {Object} query
 * @param {boolean} [shouldEncode=true]
 * @return {string}
 */
function stringify (query, shouldEncode) {
  if (shouldEncode === void 0) shouldEncode = true

  if (!query) {
    return ''
  }

  var encode = shouldEncode ? encodeURIComponent : returnVal

  return Object.keys(query).map(function (key) {
    var value = query[key]
    key = encode(key)

    if (Array.isArray(value)) {
      return value.map(function (item, index) { return key + '[' + index + ']=' + encode(item) }).join('&')
    } else {
      return key + '=' + encode(value)
    }
  }).join('&')
}

export default {
  parse,
  stringify
}
